import { remoteInvoke } from "@quatico/magellan-client";
// @service({"namespace": "quaweb-noauth"})
export const submitContactRequest = async (input, _context, _serialization) => {
    return remoteInvoke({ name: "submitContactRequest", data: { input: input }, namespace: "quaweb-noauth" }, _context, _serialization);
};
//# sourceMappingURL=submit-contact-request.js.map